import './App.css';
import { FirebaseProvider } from './context/firebase';
import { UserProvider } from './context/user';
import NavBar from './components/NavBar';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import { theme } from './context/theme';
import Footer from './components/Footer';
import { Box } from '@mui/material';
import { ModalServiceProvider } from './context/modal';
import { SnackBarProvider } from './context/snackbar';
import AppRouter from './components/AppRouter';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AuthAction from './pages/AuthAction';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { GoogleMapsProvider } from './context/googleMaps';
import AccountVerifier from './components/client/AccountVerifier';
import { AiPanelProvider } from './context/aiPanel';
import AiPanel, { AiPanelLauncher } from './components/ai/AiPanel';
import OutcomeNotifier from './components/client/OutcomeNotifier';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

// Branded Firebase email-action handler (/auth/action) renders full-page and
// role-independent; everything else renders the normal app chrome.
const AppContent = () => {
  const location = useLocation();
  if (location.pathname.startsWith('/auth/action')) {
    return <AuthAction />;
  }
  return (
    <AiPanelProvider>
      {/* StackIQ panel sits in-flow on the left and pushes the app aside, so
          users can chat while working with the page. */}
      <Box display="flex" flexDirection="row" flex={1} overflow="hidden">
        <AiPanel />
        <Box display="flex" flexDirection="column" flex={1} minWidth={0} overflow="hidden">
          <NavBar />
          <AccountVerifier />
          {/* Renders nothing; toasts re-use request outcomes while the tab is open. */}
          <OutcomeNotifier />
          <Box flex={1} overflow="auto" display="flex" flexDirection="column">
            <AppRouter />
          </Box>
          <Footer />
        </Box>
      </Box>
      <AiPanelLauncher />
    </AiPanelProvider>
  );
};

const App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {/* SnackBarContext as outtermost as Firebaseprovider may need to show network errors */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackBarProvider>
            <GoogleMapsProvider>
              <Router>
                <UserProvider>
                  <FirebaseProvider>
                    <ModalServiceProvider>
                      <AppContent />
                    </ModalServiceProvider>
                  </FirebaseProvider>
                </UserProvider>
              </Router>
            </GoogleMapsProvider>
          </SnackBarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
